<template>
    <chart-card>
        <template slot="header">
            <h4 class="card-title">Movimentação de Vendas</h4>
        </template>
        <template slot="footer">
            <hr>
            <div class="stats">
                <i class="fa fa-clock-o"></i> Ultima atualização: {{lastUpdatedFormated}}
            </div>
        </template>
        <div id="chart">
            <div class="toolbar">
                <button id="week"
                        @click="updateData('week')" :class="{active: selection==='week'}">Semana
                </button>

                <button id="month"
                        @click="updateData('month')" :class="{active: selection==='month'}">Mês
                </button>

                <button id="all"
                        @click="updateData('all')" :class="{active: selection==='all'}">Tudo
                </button>
            </div>

            <div id="chart-timeline">
                <apexchart type="area" height="350" ref="chart" :options="chartOptions" :series="series"></apexchart>
            </div>
        </div>
    </chart-card>
</template>

<script>
    import ChartCard from "@/components/ChartCard";
    import moment from 'moment';

    export default {
        name: "LineByDay",
        components: {ChartCard},
        props: ['chartData','lastUpdated'],
        computed:{
            lastUpdatedFormated (){
                return moment(this.lastUpdated, 'YYYY-MM-DD').format('DD/MM/YYYY [às] HH:mm:ss')
            }
        },
        data: function () {
            return {
                series: [{
                    name: 'Casos',
                    data: [

                    ]
                }],
                chartOptions: {
                    chart: {
                        id: 'area-datetime',
                        type: 'area',
                        height: 350,
                        zoom: {
                            autoScaleYaxis: true
                        }
                    },
                    dataLabels: {
                        enabled: false
                    },
                    markers: {
                        size: 0,
                        style: 'hollow',
                    },
                    xaxis: {
                        type: 'datetime',
                        min: new Date('14 Nov 2020').getTime(),
                        tickAmount: 6,
                        labels: {
                            datetimeFormatter: {
                                year: 'yyyy',
                                month: 'MM/yyyy',
                                day: 'dd/MM/yyyy',
                                hour: 'HH:mm'
                            }
                        }
                    },
                    tooltip: {
                        x: {
                            format: 'dd/mm/yyyy'
                        }
                    },
                    fill: {
                        type: 'gradient',
                        gradient: {
                            shadeIntensity: 1,
                            opacityFrom: 0.7,
                            opacityTo: 0.9,
                            stops: [0, 100]
                        }
                    },
                },
                selection: 'all',
            }
        },
        watch:{
            chartData(){
                var self = this;
                this.chartData.forEach(function (data) {
                    self.series[0].data.push([moment(data.date).unix()*1000, data.cases])
                });
                self.updateData('all');
                self.updateData('all');
            }
        },
        methods: {
            updateData: function(timeline) {
                this.selection = timeline

                switch (timeline) {
                    case 'week':
                        this.$refs.chart.zoomX(
                            moment().startOf('week').unix()*1000,
                            moment().endOf('week').unix()*1000
                        )
                        break
                    case 'month':
                        this.$refs.chart.zoomX(
                            moment().startOf('month').unix()*1000,
                            moment().endOf('month').unix()*1000
                        )
                        break
                    case 'all':
                        this.$refs.chart.zoomX(
                            this.$refs.chart.series[0].data[0][0],
                            this.$refs.chart.series[0].data[this.$refs.chart.series[0].data.length-1][0],
                        )
                        break
                    default:
                }
            }
        }
    }
</script>

<style scoped>
    button{
        margin: 3px;
        font-family: Arial;
        background: #fff;
        color: #222;
        border: 1px solid #e7e7e7;
        border-bottom: 2px solid #ddd;
        border-radius: 2px;
        padding: 4px 17px;
    }
    button.active{
        font-family: Arial;
        border-radius: 2px;
        padding: 4px 17px;
        color: #fff;
        background: #008FFB;
        border: 1px solid blue;
        border-bottom: 2px solid blue;
    }
</style>
